import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import { SpeedInsights } from '@vercel/speed-insights/react';
import { Analytics } from '@vercel/analytics/react';

// Páginas
import HomePage from './pages/HomePage';
import TherapistPage from './pages/TherapistPage';
import BlogPage from './pages/BlogPage';
import BookingWizard from './components/Booking/BookingWizard';
import TherapistPortal from './pages/TherapistPortal';
import PaymentPage from './pages/PaymentPage';
import PaymentResultPage from './pages/PaymentResultPage';
import NotFoundPage from './pages/NotFoundPage';
import ActivateAccountPage from './pages/ActivateAccountPage';
import PrivacyPage from './pages/PrivacyPage';

import MetaPixel from './components/SEO/MetaPixel';
import GoogleAnalytics from './components/SEO/GoogleAnalytics';
import CookieConsentBanner from './components/CookieConsent/CookieConsentBanner';
import ErrorBoundary from './components/ErrorBoundary/ErrorBoundary';
import { ToastProvider } from './components/ui/ToastProvider';
import { ConfirmProvider } from './components/ui/ConfirmProvider';

// Test de servicios (solo en desarrollo)
import BasicTest from './test/basic-test';

// Estilos
import './assets/css/modern-style.css';
import './assets/css/floating-buttons.css';
import './assets/css/animations.css';
import './App.css';

/**
 * Componente principal de la aplicación con React Router
 * Conectemos Chile - Clínica de Atención Psicológica
 */
function App() {
  return (
    <HelmetProvider>
      <Router>
        <div className="App">
          <ErrorBoundary>
          <ToastProvider>
          <ConfirmProvider>
          <Routes>
            {/* Página principal */}
            <Route path="/" element={<HomePage />} />
            
            {/* Páginas individuales de terapistas */}
            <Route path="/terapista/:slug" element={<TherapistPage />} />
            
            {/* Blog profesional */}
            <Route path="/blog" element={<BlogPage />} />
            
            {/* Sistema de agendamiento */}
            <Route path="/agendar" element={<BookingWizard />} />

            {/* Política de privacidad (wisest-labs/02 §3.5, D-5) */}
            <Route path="/privacidad" element={<PrivacyPage />} />
            
            {/* Portal de terapeutas — la vista activa vive en la URL (/panel/:view)
                para que el botón atrás del navegador funcione y se puedan
                compartir links a una vista puntual. Ver docs/UX_VISION.md P1-6. */}
            <Route path="/panel" element={<TherapistPortal />} />
            <Route path="/panel/:view" element={<TherapistPortal />} />
            <Route path="/agenda_terapeuta" element={<TherapistPortal />} />

            {/* Activación de credencial de paciente (FUNC-124 / SEC-064) — link del correo de invitación */}
            <Route path="/activar-cuenta" element={<ActivateAccountPage />} />

            {/* Pago Transbank */}
            <Route path="/pagar/:consultaId" element={<PaymentPage />} />
            <Route path="/pago/resultado"    element={<PaymentResultPage />} />
            
            {/* Test de servicios - solo en desarrollo */}
            {process.env.NODE_ENV === 'development' && (
              <Route path="/test-basic" element={<BasicTest />} />
            )}
            
            {/* Ruta de fallback - 404 real (noindex), no la Home */}
            <Route path="*" element={<NotFoundPage />} />
          </Routes>
          </ConfirmProvider>
          </ToastProvider>
          </ErrorBoundary>

          {/* Vercel Analytics y Speed Insights */}
          <Analytics />
          <SpeedInsights />
          <MetaPixel />
          <GoogleAnalytics />
          <CookieConsentBanner />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;